import { YesNoAnswer } from "src/types/commons.types";
import { formatDate, mergeDateAndTime, splitDateTime } from "src/utils";

export const YesNoAnswerMapper = {
  toDto(form: YesNoAnswer): boolean {
    return form === YesNoAnswer.YES;
  },

  fromDto(dto?: boolean): YesNoAnswer {
    return dto ? YesNoAnswer.YES : YesNoAnswer.NO;
  },
};

export const DateMapper = {
  parseDate(dateStr: string, format: "DD/MM/YYYY" | "YYYY-MM-DD"): Date | null {
    try {
      if (!dateStr || typeof dateStr !== "string") {
        return null;
      }

      const separator = format.includes("/") ? "/" : "-";
      const parts = dateStr.split(separator);

      if (parts.length !== 3) {
        return null;
      }

      let day: number, month: number, year: number;

      if (format === "DD/MM/YYYY") {
        [day, month, year] = parts.map((p) => parseInt(p));
      } else {
        // YYYY-MM-DD
        [year, month, day] = parts.map((p) => parseInt(p));
      }

      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return null;
      }

      const date = new Date(year, month - 1, day);

      // Verify if date is valid
      if (
        date.getDate() !== day ||
        date.getMonth() !== month - 1 ||
        date.getFullYear() !== year
      ) {
        return null;
      }

      return date;
    } catch (error) {
      console.error("Error parsing date:", error);
      return null;
    }
  },

  toDto(dateForm: string): string {
    const date = this.parseDate(dateForm, "DD/MM/YYYY");
    return date ? formatDate(date, "DD/MM/YYYY", "YYYY-MM-DD") : "";
  },

  fromDto(dateDto: string): string {
    const date = this.parseDate(dateDto, "YYYY-MM-DD");
    return date ? formatDate(date, "YYYY-MM-DD", "DD/MM/YYYY") : "";
  },
};

export const DateTimeMapper = {
  toDto(dateForm: string, timeForm: string): string {
    return mergeDateAndTime(dateForm, timeForm) ?? "";
  },

  fromDto(isoString: string): { date?: string; time?: string } {
    return splitDateTime(isoString);
  },
};
